export { default } from './ErrorText';
